<div class="intercom-dialog-form-bank">
  <div class="header">
    <span class="title">Nueva cuenta bancaria</span>
    <lib-icon style="cursor: pointer;" icon="close" (click)="cancel()" size="xxs"></lib-icon>
  </div>
  <app-bank-account-form [isButtonFullWidth]="true" [availableCurrency]="availableCurrency" mode="create"
    (onSubmit)="submitHandler($event)" (errorSubmit)="sendError($event)">
  </app-bank-account-form>
</div>